// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RouteModal_overlay__gozig {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.RouteModal_content__Jb64W {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1001;
}

.RouteModal_closeButton__T6LnU {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 1.4rem;
  cursor: pointer;
}

.RouteModal_title__\\+Fyk3 {
  margin: 0 0 8px;
  font-size: 1.5rem;
  font-weight: 600;
}

.RouteModal_meta__w5bHk {
  margin: 0 0 16px;
  color: #555;
  font-size: 0.9rem;
}

.RouteModal_formRow__1ePNR {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.RouteModal_formRow__1ePNR label {
  flex: 0 0 120px;
  font-size: 0.95rem;
  font-weight: 500;
}
.RouteModal_formRow__1ePNR select {
  flex: 1 1;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.95rem;
  background: #fff;
}

.RouteModal_squaresScroll__ZnS4o {
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 20px;
}

.RouteModal_squareWrapper__xWPz5 {
  position: relative;
}

.RouteModal_statusSquare__M9ehv {
  width: 20px;
  height: 20px;
  border-radius: 2px;
}
.RouteModal_green__zKiyJ { background: rgb(40, 167, 69); }
.RouteModal_red__hku9d   { background: #ef4444; }
.RouteModal_blue__XEoQj  { background: #3b82f6; }

.RouteModal_tooltip__p5buw {
  position: fixed !important;
  z-index: 2000;
  background: rgba(60,60,60,0.95);
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.85rem;
  pointer-events: none;
  max-width: 300px;
  word-wrap: break-word;
}

.RouteModal_tooltipContent__rU6Vo p {
  margin: 4px 0;
  line-height: 1.3;
}

.RouteModal_tooltipContent__rU6Vo .RouteModal_link__koBmK {
  cursor: pointer;
  text-decoration: underline;
}

.RouteModal_productsList__-8UFk {
  margin: 4px 0 0 0;
  padding-left: 16px;
}

.RouteModal_executeButton__s6UAq {
  width: 100%;
  padding: 12px;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
}

.RouteModal_executeButton__s6UAq:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/AccessManagement/components/RouteModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA,2BAAS,4BAA4B,EAAE;AACvC,2BAAS,mBAAmB,EAAE;AAC9B,2BAAS,mBAAmB,EAAE;;AAE9B;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 1000;\r\n}\r\n\r\n.content {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  padding: 24px;\r\n  width: 600px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  z-index: 1001;\r\n}\r\n\r\n.closeButton {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 16px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.4rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.title {\r\n  margin: 0 0 8px;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.meta {\r\n  margin: 0 0 16px;\r\n  color: #555;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.formRow {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n}\r\n.formRow label {\r\n  flex: 0 0 120px;\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n}\r\n.formRow select {\r\n  flex: 1;\r\n  padding: 6px 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 0.95rem;\r\n  background: #fff;\r\n}\r\n\r\n.squaresScroll {\r\n  max-height: 180px;\r\n  overflow-y: auto;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  padding: 8px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.squareWrapper {\r\n  position: relative;\r\n}\r\n\r\n.statusSquare {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 2px;\r\n}\r\n.green { background: rgb(40, 167, 69); }\r\n.red   { background: #ef4444; }\r\n.blue  { background: #3b82f6; }\r\n\r\n.tooltip {\r\n  position: fixed !important;\r\n  z-index: 2000;\r\n  background: rgba(60,60,60,0.95);\r\n  color: #fff;\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  font-size: 0.85rem;\r\n  pointer-events: none;\r\n  max-width: 300px;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.tooltipContent p {\r\n  margin: 4px 0;\r\n  line-height: 1.3;\r\n}\r\n\r\n.tooltipContent .link {\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n}\r\n\r\n.productsList {\r\n  margin: 4px 0 0 0;\r\n  padding-left: 16px;\r\n}\r\n\r\n.executeButton {\r\n  width: 100%;\r\n  padding: 12px;\r\n  background: #2563eb;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n}\r\n\r\n.executeButton:disabled {\r\n  background: #9ca3af;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `RouteModal_overlay__gozig`,
	"content": `RouteModal_content__Jb64W`,
	"closeButton": `RouteModal_closeButton__T6LnU`,
	"title": `RouteModal_title__+Fyk3`,
	"meta": `RouteModal_meta__w5bHk`,
	"formRow": `RouteModal_formRow__1ePNR`,
	"squaresScroll": `RouteModal_squaresScroll__ZnS4o`,
	"squareWrapper": `RouteModal_squareWrapper__xWPz5`,
	"statusSquare": `RouteModal_statusSquare__M9ehv`,
	"green": `RouteModal_green__zKiyJ`,
	"red": `RouteModal_red__hku9d`,
	"blue": `RouteModal_blue__XEoQj`,
	"tooltip": `RouteModal_tooltip__p5buw`,
	"tooltipContent": `RouteModal_tooltipContent__rU6Vo`,
	"link": `RouteModal_link__koBmK`,
	"productsList": `RouteModal_productsList__-8UFk`,
	"executeButton": `RouteModal_executeButton__s6UAq`
};
export default ___CSS_LOADER_EXPORT___;
